import { useEffect, useRef } from 'react';
import { resolveKeyShortcutHandler } from 'utils/key-shortcuts';
import { UseKeyShortcutsParams } from './use-key-shortcuts-params';

export function useKeyShortcuts({
  bindings,
  enabled = true
}: UseKeyShortcutsParams): void {
  const bindingsRef = useRef(bindings);
  bindingsRef.current = bindings;

  useEffect(() => {
    if (!enabled) return undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      const handler = resolveKeyShortcutHandler(event, bindingsRef.current);
      if (!handler) return;
      event.preventDefault();
      handler();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled]);
}
